<template>
  <el-table ref="multipleTable" :data="tableData" style="width: 100%" header-cell-class-name="header-cell" show-summary
            class="part-child-container">
    <el-table-column v-if="canRadio" width="40">
      <template slot-scope="scope">
        <el-radio v-model="radioOrder" :label="scope.row" class="radio-order"/>
      </template>
    </el-table-column>
    <el-table-column label="订单">
      <template slot-scope="{$index}">
        子订单 {{ $index + 1 }}
      </template>
    </el-table-column>
    <el-table-column prop="order_no" label="订单编号" width="165">
      <template slot-scope="scope">
        <to-order-detail :order="scope.row"/>
      </template>
    </el-table-column>
    <el-table-column prop="order_source" label="订单来源"/>
    <el-table-column prop="payment_account" label="含税收入" align="right">
      <template slot-scope="{row}">
        {{ $utils.numberFormat(row.payment_account, 2) }}
      </template>
    </el-table-column>
    <el-table-column prop="invoice_money_done" label="已申请开票金额" width="130" align="right">
      <template slot-scope="{row}">
        {{ $utils.numberFormat(row.invoice_money_done || 0, 2) }}
      </template>
    </el-table-column>
    <el-table-column prop="invoice_money_occupy" label="申请中开票金额" width="130" align="right">
      <template slot-scope="{row}">
        {{ $utils.numberFormat(row.invoice_money_occupy || 0, 2) }}
      </template>
    </el-table-column>
    <el-table-column prop="sum_amount" label="回款金额" align="right">
      <template slot-scope="{row}">
        {{ $utils.numberFormat(row.sum_amount || 0, 2) }}
      </template>
    </el-table-column>
    <el-table-column prop="artist_nickname" label="红人"/>
    <el-table-column prop="executor_name" label="执行"/>
    <el-table-column prop="agent_name" label="经纪人"/>
    <el-table-column prop="release_timestamp_alias" label="发布日期" width="100"/>
    <el-table-column prop="created_timestamp_alias" label="下单日期" width="100"/>
    <el-table-column prop="platforms" label="发布平台"/>
    <el-table-column prop="content_forms" label="内容(发布)形式" width="120"/>
    <el-table-column prop="rebates_rate" label="返点比例%" width="100"/>
    <el-table-column prop="platform_fee_po" label="代下单平台费" width="110"/>
    <el-table-column prop="weal_price" label="粉丝福利"/>
    <el-table-column prop="authorized_price" label="授权价"/>
    <el-table-column prop="micro_task_price" label="微任务价"/>
    <el-table-column prop="other_fee" label="其他费"/>
    <el-table-column prop="pay_method_alias" label="支付方式"/>
    <el-table-column prop="is_trailer_alias" label="是否挂车"/>
    <el-table-column prop="commission_trailer" label="挂车佣金%" width="100"/>
    <el-table-column prop="cart_charges" label="购物车费用"/>
    <el-table-column prop="is_lb_alias" label="是否直播"/>
    <el-table-column prop="commission_rate" label="直播佣金%" width="100"/>
    <el-table-column prop="cart_commission" label="坑位费"/>
  </el-table>
</template>

<script>
import ToOrderDetail from "@/views/adOrder/components/ToDetail";

/**
 * 子订单信息
 */
export default {
  name: "PartChildOrders",
  components: {ToOrderDetail},
  props: {
    tableData: {
      type: Array,
      default() {
        return []
      }
    },
    canRadio: Boolean,
  },
  data() {
    return {
      radioOrder: null,
    }
  },
  methods: {}
}
</script>
<style lang="scss">
.part-child-container {
  .radio-order {
    .el-radio__label {
      display: none;
    }
  }
}
</style>